import type { StepFlowLang } from '@/components/step-flow/StepFlowShell.types';
import type { SampleNoteSection } from '@/pages/onboarding/onboarding.types';
import type { NoteDetail } from '@/types/noteStyle';

/** The design's example note (low back pain) for step 3, one per detail level. Fictional. */
export const noteSamples: Record<StepFlowLang, Record<NoteDetail, SampleNoteSection[]>> = {
  is: {
    short: [
      { heading: 'Saga', body: 'Mjóbaksverkur í 2 vikur.' },
      { heading: 'Áætlun', body: 'Æfingar, endurmat eftir 2 vikur.' },
    ],
    balanced: [
      { heading: 'Saga', body: 'Mjóbaksverkur í 2 vikur, versnar við setu. Verkur 6/10. Engin rauð flögg.' },
      { heading: 'Skoðun', body: 'Eymsli yfir L4–L5. Eðlileg taugaskoðun.' },
      { heading: 'Áætlun', body: 'Kjarnaæfingar og hiti. Endurmat eftir 2 vikur.' },
    ],
    detailed: [
      {
        heading: 'Saga',
        body: 'Mjóbaksverkur í 2 vikur eftir flutninga. Versnar við langa setu, skánar við göngu. Verkur 6/10, leiðir ekki niður í fætur. Engin rauð flögg: eðlileg þvaglát, enginn hiti, ekkert þyngdartap.',
      },
      {
        heading: 'Skoðun',
        body: 'Eymsli yfir L4–L5 hægra megin. Skert framsveigja. SLR neikvætt beggja vegna. Kraftar, skyn og viðbrögð eðlileg.',
      },
      {
        heading: 'Áætlun',
        body: 'Kjarna- og teygjuæfingar daglega, hiti eftir þörfum. Forðast langa setu. Endurmat eftir 2 vikur, fyrr ef einkenni versna.',
      },
    ],
  },
  en: {
    short: [
      { heading: 'History', body: 'Low back pain for 2 weeks.' },
      { heading: 'Plan', body: 'Exercises, review in 2 weeks.' },
    ],
    balanced: [
      { heading: 'History', body: 'Low back pain for 2 weeks, worse when sitting. Pain 6/10. No red flags.' },
      { heading: 'Examination', body: 'Tenderness over L4–L5. Normal neurological exam.' },
      { heading: 'Plan', body: 'Core exercises and heat. Review in 2 weeks.' },
    ],
    detailed: [
      {
        heading: 'History',
        body: 'Low back pain for 2 weeks after moving house. Worse with prolonged sitting, better when walking. Pain 6/10, no radiation to the legs. No red flags: normal bladder function, no fever, no weight loss.',
      },
      {
        heading: 'Examination',
        body: 'Tenderness over right L4–L5. Reduced flexion. SLR negative bilaterally. Power, sensation and reflexes normal.',
      },
      {
        heading: 'Plan',
        body: 'Daily core and stretching exercises, heat as needed. Avoid prolonged sitting. Review in 2 weeks, sooner if symptoms worsen.',
      },
    ],
  },
};
